module.exports = __webpack_public_path__ + "static/vision_text_mobile-177e8af268e472914e485f5a68e9fcec.svg";